import * as K from 'common/constants';
import { isRelativeUrlValidRoute } from 'common/functions';

// Components
import RedirectToHomePage from 'components/common/Router/RedirectToHome';
import AlertListPage from 'components/alerts/AlertListPage/AlertListPage';
import AlertDetailsPage from 'components/alerts/AlertDetailsPage/AlertDetailsPage';
import ApiKeysPage from 'components/other/ApiKeysPage/ApiKeysPage';
import AuthPage from 'components/auth/AuthPage';
import ExamplesPage from 'components/examples/ExamplesPage';
import LogOverviewPage from 'components/overview/LogOverviewPage/LogOverviewPage';
import DashboardRouter from 'components/dashboards/DashboardRouter/DashboardRouter';
import DashboardListPage from 'components/dashboards/DashboardListPage/DashboardListPage';
import LabsPage from 'components/labs/LabsPage/LabsPage';
import BulkExportsPage from 'components/bulkExports/BulkExportsPage';
import ChangePasswordPage from 'components/changePassword/ChangePasswordPage';
import UserAccountsPage from 'components/userAccounts/userAccountPage';
import ManageGroupsPage from 'components/manageGroups/ManageGroupsPage';
import ParsersPage from 'components/Parsers/ParsersPage';
import LogParseTesterPage from 'components/Parser/LogParseTesterPage';
import ParserRouter from 'components/Parser/ParserRouter';
import ConfigurationFilesPage from 'components/configurationFiles/ConfigurationFilesPage';
import FileRouter from 'components/ConfigurationFile/FileRouter';
import UpdateCreditCardPage from 'components/updateCreditCard/updateCreditCardPage';
import LogProcessingPage from 'components/logProcessing/LogProcessingPage';
import LinkAccountPage from 'components/linkAccount/linkAccountPage';
import BillingAndUsagePage from 'components/billingAndUsage/BillingAndUsagePage';
import VerifyEmailPage from 'components/verifyEmail/VerifyEmailPage';
import AcceptLinkInvitePage from 'components/acceptInviteLink/AcceptLinkInvitePage';
import ChangePasswordPublicPage from 'components/changePasswordPublic/ChangePasswordPublicPage';
import EmailVerificationTrialPage from 'components/emailVerificationTrial/EmailVerificationTrialPage';
import MonitorsPage from 'components/monitors/Monitors';
import PageNotFound from 'components/other/404/PageNotFound';
import SecretsPage from 'components/Secrets/SecretsPage';
import SlackOAuthPage from 'components/SlackOAuthPage/SlackOAuthPage';
import HelpPage from 'components/help/HelpPage';
import SearchLogsPage from 'components/search/SearchLogsPage/SearchLogsPage';
import SearchGraphsPage from 'components/search/SearchGraphsPage/SearchGraphsPage';
import DistributionPage from 'components/search/DistributionPage/DistributionPage';
import SearchTracesPage from 'components/search/SearchTracesPage/SearchTracesPage';
import LiveTailPage from 'components/search/LiveTailPage/LiveTailPage';
import PowerQueriesPage from 'components/search/PowerQueriesPage/PowerQueriesPage';
import SignUpPageInternal from 'components/auth/SignUpPageInternal';
import SSOInvite from 'components/auth/SSOInvite';

/* Representing the router as a static Record allows us to leverage typescript to enforce handling all routes */
const router: Record<K.ROUTE, JSX.Element> = {
  [K.ROUTE.ACCEPT_LINK_INVITE]: <AcceptLinkInvitePage />,
  [K.ROUTE.ALERT]: <AlertDetailsPage />,
  [K.ROUTE.ALERTS]: <AlertListPage />,
  [K.ROUTE.BULK_EXPORTS]: <BulkExportsPage />,
  [K.ROUTE.CHANGE_PASSWORD]: <ChangePasswordPage />,
  [K.ROUTE.CONFIG]: <ConfigurationFilesPage />,
  [K.ROUTE.CONFIG_FILE]: <FileRouter />,
  [K.ROUTE.DASHBOARD]: <DashboardRouter />,
  [K.ROUTE.DASHBOARD_LIST]: <DashboardListPage />,
  [K.ROUTE.DISTRIBUTION]: <DistributionPage />,
  [K.ROUTE.EMAIL_VERIFICATION]: <EmailVerificationTrialPage />,
  [K.ROUTE.EVENTS]: <SearchLogsPage />,
  [K.ROUTE.EXAMPLES]: <ExamplesPage />,
  [K.ROUTE.GRAPH]: <SearchGraphsPage />,
  [K.ROUTE.HELP]: <HelpPage />,
  [K.ROUTE.KEYS]: <ApiKeysPage />,
  [K.ROUTE.LABS]: <LabsPage />,
  [K.ROUTE.LIVE_TAIL]: <LiveTailPage />,
  [K.ROUTE.LOG_IN]: <AuthPage />,
  [K.ROUTE.LOG_IMPORT_TESTER]: <LogParseTesterPage />,
  [K.ROUTE.LOG_PARSE_TESTER]: <LogParseTesterPage />,
  [K.ROUTE.LOG_PROCESSING]: <LogProcessingPage />,
  [K.ROUTE.LOG_START]: <LogOverviewPage />,
  [K.ROUTE.MANAGE_GROUPS]: <ManageGroupsPage />,
  [K.ROUTE.MANAGE_TEAMS]: <LinkAccountPage />,
  [K.ROUTE.MANAGE_USERS]: <UserAccountsPage />,
  [K.ROUTE.MONITORS_PAGE]: <MonitorsPage />,
  [K.ROUTE.PAGE_NOT_FOUND]: <PageNotFound />,
  [K.ROUTE.PARSER]: <ParserRouter />,
  [K.ROUTE.PARSERS]: <ParsersPage />,
  [K.ROUTE.PASSWORD_RESET]: <ChangePasswordPublicPage />,
  [K.ROUTE.PLAN]: <BillingAndUsagePage />,
  [K.ROUTE.POWER_QUERY]: <PowerQueriesPage />,
  [K.ROUTE.ROOT]: <RedirectToHomePage />,
  [K.ROUTE.SECRETS]: <SecretsPage />,
  [K.ROUTE.SIGN_UP_INTERNAL]: <SignUpPageInternal />,
  [K.ROUTE.SIGN_UP_FORM]: <PageNotFound />,
  [K.ROUTE.SLACK_OAUTH]: <SlackOAuthPage />,
  [K.ROUTE.SSO_INVITE]: <SSOInvite />,
  [K.ROUTE.TRACE]: <SearchTracesPage />,
  [K.ROUTE.TRY_SCALYR_FORM]: <PageNotFound />,
  [K.ROUTE.UPDATE_CREDIT_CARD]: <UpdateCreditCardPage />,
  [K.ROUTE.VERIFY_EMAIL]: <VerifyEmailPage />,
};

export const getRouteComponent = (route: K.ROUTE) => router[route];

export const isPathValidScalyrRoute = (path?: string) => isRelativeUrlValidRoute(path || '', Object.keys(router));
